import { palette } from '@client/theme/colors';
import { radii, theme } from '@client/theme/constants';
import { typography } from '@client/theme/typography';
import type { ThemeOptions } from '@mui/material';

declare module '@mui/material/Alert' {
  interface AlertPropsColorOverrides {
    primary: true;
    secondary: true;
  }
}

const Alert: ThemeOptions['components'] = {
  MuiAlert: {
    defaultProps: {
      icon: false,
      severity: 'info',
    },
    styleOverrides: {
      root: {
        ...typography.caption,
        color: palette.grey[700],
        alignItems: 'center',
        borderRadius: radii.small,
        flexWrap: 'wrap',
        padding: theme.spacing(1, 1.5),

        '&[type="button"]': {
          height: 'auto !important',
        },
      },
      action: {
        paddingTop: 0,

        '& > a': {
          marginRight: theme.spacing(1),
          fontSize: typography.caption.fontSize,
          lineHeight: typography.caption.lineHeight,
        },

        '& > p': {
          marginRight: theme.spacing(1),
        },

        '& > button > svg': {
          color: palette.grey[50],
        },

        [theme.breakpoints.down('md')]: {
          marginBottom: theme.spacing(1 / 2),
        },
      },
      standardSuccess: {
        color: palette.grey[700],
        backgroundColor: palette.success.xlight,

        '& a': {
          color: palette.success.main,
        },
      },
      standardWarning: {
        color: palette.grey[700],
        backgroundColor: palette.warning.xlight,

        '& a': {
          color: palette.warning.main,
        },
      },
      standardError: {
        color: palette.grey[700],
        backgroundColor: palette.error.xlight,

        '& a': {
          color: palette.error.dark,
        },
      },
      standardInfo: {
        color: palette.grey[700],
        backgroundColor: palette.grey[200],
      },
      message: {
        flex: '1 0 auto',
        display: 'block',
        maxWidth: '100%',
        textAlign: 'left',
        padding: 0,
      },
    },
    variants: [
      {
        props: { color: 'primary' },
        style: {
          color: palette.grey[700],
          backgroundColor: palette.primary.xlight,

          '& a': {
            color: palette.primary.main,
          },
        },
      },
      {
        props: { color: 'secondary' },
        style: {
          color: palette.grey[700],
          backgroundColor: palette.secondary.xlight,

          '& a': {
            color: palette.secondary.main,
          },
        },
      },
    ],
  },
  MuiAlertTitle: {
    styleOverrides: {
      root: typography.body2,
    },
  },
  MuiSnackbar: {
    styleOverrides: {
      anchorOriginBottomCenter: {
        left: theme.spacing(2),
        bottom: theme.spacing(2),
        right: theme.spacing(2),

        [theme.breakpoints.up('sm')]: {
          maxWidth: 444,
        },
      },
    },
  },
};

export default Alert;
